import { ModalProvider } from '@leroy-merlin-br/backyard-react-ui'

import reactComponentLoader from 'scripts/react-component-loader'

import Product from './pages/Product'
import { PostalCode } from './pages/Product/components/PostalCode'
import { FooterAd } from './pages/Family/components/Ads'

const PostalCodeWithModalProvider = (props) => (
  <ModalProvider>
    <PostalCode {...props} />
  </ModalProvider>
)

reactComponentLoader(Product, '[data-product-page]')
reactComponentLoader(PostalCodeWithModalProvider, '[data-postal-code]')
reactComponentLoader(FooterAd, '[data-family-gpt]')
